import { Link } from "react-router-dom";
import { studentWorkspacePaths } from "@/utils/student-workspace";

export function AssessmentStartPanel({
  title = "请先选择儿童并开始评估",
  description = "打开评估选择页后，系统只会在你点击开始或继续时创建或恢复评估记录。",
  studentId
}: {
  title?: string;
  description?: string;
  studentId?: string;
}): JSX.Element {
  return (
    <section className="rounded-xl border border-dashed border-brand/40 bg-brand/5 p-8 text-center shadow-sm">
      <h2 className="text-lg font-semibold text-slate-800">{title}</h2>
      <p className="mx-auto mt-2 max-w-2xl text-sm text-slate-600">{description}</p>
      <Link
        to={studentId ? studentWorkspacePaths.assessments(studentId) : studentWorkspacePaths.children}
        className="mt-5 inline-flex min-h-11 items-center justify-center rounded-md bg-brand px-4 py-2 text-sm font-semibold text-white shadow-sm transition hover:bg-brand-dark focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2"
      >
        {studentId ? "返回评估" : "返回全部儿童"}
      </Link>
    </section>
  );
}
